//libs
import React, { useCallback } from 'react';
import c from 'classnames';
import { NodeSelection } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';

//components
import { Box, Stack } from '@lyearn/ui';

import { FLASH_CARDS } from '../../../../nodes/FlashCard/consts';
import { setNodeAttrs } from '../../../../utils';
//styles
import { setBackground } from './styles';

interface FlashCardTypesProps {
  view: EditorView;
}

const FlashCardTypes: React.FC<FlashCardTypesProps> = (props) => {
  const { view } = props;

  const onClick = useCallback(
    (event: any) => {
      if (!view) {
        return;
      }
      const flashCardType = event.currentTarget.getAttribute('data-flashcard-type');
      const currentSelectionNode = (view.state.selection as NodeSelection).node;
      setNodeAttrs(view, view.state.selection.$from.pos, {
        ...currentSelectionNode?.attrs,
        type: flashCardType,
      });
    },
    [view],
  );

  return (
    <Stack alignItems="center" className="p-6 pe-2">
      {FLASH_CARDS.map((flashCardType) => (
        <Box
          key={flashCardType.id}
          className="cursor-pointer rounded-4 p-4 me-4 hover:bg-interactive-white-hover"
          data-flashcard-type={flashCardType.id}
          role="button"
          onClick={onClick}>
          <Box
            className={c('h-20 w-20 rounded-full', setBackground(flashCardType.front.background))}
          />
        </Box>
      ))}
    </Stack>
  );
};

export default FlashCardTypes;
